/**
 * Acts as a detail report to the parcel info-viewer to render associated addresses
 */
import Utils = require("../utils");
import $ = require("jquery");

function render(feature: Rhythm.GIS.FeatureQueryResultFeature, args: {
    layerOptions: Rhythm.GIS.Dictionary<string>;
}) {
    let fieldList = args.layerOptions["field-list"] ? Utils.split(args.layerOptions["field-list"]) : [""];
    let primaryFieldList = Utils.split(args.layerOptions["primary-field"] || fieldList[0]);
    let showLabels = args.layerOptions["show-labels"] === "true";

    let fieldLabelMap = [];

    if (showLabels) {
        let fieldLabels = args.layerOptions["field-labels"] ? Utils.split(args.layerOptions["field-labels"]) : fieldList;
        fieldList.forEach((id, i) => fieldLabelMap[id] = fieldLabels[i]);
    }

    let keys = Object.keys(feature.attributes);

    let details = "";
    // preserves field order limited to valid keys
    if (Array.isArray(fieldList)) {

        let isVisible = d => typeof d in { string: 1, number: 1 };

        let doit = (showLoading = false) => {

            let fieldData = Utils.distinct([].concat(primaryFieldList, fieldList))
                .map(k => ({ id: k, data: Utils.data(feature.attributes, k) }))
                .filter(k => isVisible(k.data));

            details = fieldData
                .filter(k => 0 <= fieldList.indexOf(k.id))
                .sort((a, b) => fieldList.indexOf(a.id) - fieldList.indexOf(b.id))
                .map(k => `<tr class='${k.id}'><td><label class='name ${!showLabels ? "hidden" : ""}'>${fieldLabelMap[k.id] || k.id}</label></td><td><label class='value'>${k.data}</label></td></tr>`)
                .join('');
            let wrapper = $('<div class="associated-info-link">');
            let expandIcon = $('<label class="link-plus" style="">&#43;</label>');
            let collapseIcon = $('<label class="link-minus" style="display:none">&#45;</label>');
            let clickLabel = $(`<label class='link btn-link link-primary'>${fieldData.filter(k => 0 <= primaryFieldList.indexOf(k.id)).map(k => k.data).join(" ")}</label>`);
            wrapper.append(expandIcon);
            wrapper.append(collapseIcon);
            wrapper.append(clickLabel);
            let body = $(`<section class="body detail" style="display:none"><table class='infoviewer-grid detail'><tbody>${details}</tbody></table></section>`);
            wrapper.click(() => {
                expandIcon.toggle();
                collapseIcon.toggle();
                body.fadeToggle();
            });
            return $("<div class='associated-info-section'>").append(wrapper).append(body);
        };
        return doit()[0];

    }

}


export = render;
